<div class="custody-consult-component">
  <div class="header">
    <mat-icon svgIcon="file"></mat-icon>
    <span class="tw-align-top">{{ title }}</span>
    <mat-icon class="close-btn" svgIcon="close" (click)="close()"></mat-icon>
  </div>
  <div class="header-options">
    <div class="network-error-message-oms" *ngIf="!statusOmsOnline && !loading">{{ msgStatusOmsOffile }}</div>
    <div class="row header-tabs">
      <div (click)="changeTab(item)" *ngFor="let item of tabsCustody">
        <span class="tab" [ngClass]="{'selected-tab': item.id === model.tabSelected}">
          <span class="title">{{ item.value }}</span>
        </span>
      </div>
    </div>
    <div class="header-filter">
      <div class="flex-container form-box filters">
        <mat-radio-group id="radio-group-custody-filter" class="option-radio" [formControl]="checkCtrl"
          [(ngModel)]="model.tabFilterRadioSelected" name="custodyFilter"
          *ngFor="let filter of model?.tabConfig?.filters">
          <mat-radio-button id="radio-button-{{filter.value}}" class="mr-1" [value]="filter.id"
            *ngIf="filter.type === 'input-radio'" (click)="changeFilterTypeRadio(filter)">
            {{ filter.desc }}
          </mat-radio-button>
        </mat-radio-group>
        <div class="option-margin" *ngFor="let inputs of model?.filtersInputTab">
          <div *ngIf="inputs.type === 'input-date'">
            <mat-form-field id="date-picker-custody-filter" (click)="picker1.open()">
              <input appDatepickerMask matInput [matDatepicker]="picker1" [max]="maxDate" [placeholder]="inputs.desc"
                [(ngModel)]="inputs.value" (dateChange)="changeDate(inputs, null, dateCustodyFilter, dateCustodyFilter)"
                (keypress)="validChar($event)" disabled required>
              <mat-datepicker-toggle matSuffix [for]="picker1" required></mat-datepicker-toggle>
              <mat-datepicker #picker1 disabled="false" required></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="option-filter" *ngIf="inputs.type === 'input-options'">
            <mat-form-field>
              <mat-select [placeholder]="inputs.desc" [(ngModel)]="model.typeCustodyHistory">
                <mat-option id="radio-button-{{type.webfeeder}}" *ngFor="let type of inputs.options" [value]="type.id"
                  (click)="search(inputs, type, model.typeCustodyHistory)">
                  {{ type.desc }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="option-complete">
            <app-auto-complete class="option-complete" [placeHolderSetter]="inputs.desc" [hideCompany]='true'
              [symbolAutoComplete]="model.symbol" #issuingAsset id="issuingAsset"
              (rawInformation)="checkForBlank($event)" (onsymbolChanged)="selectAsset($event)" [floatLabel]="true"
              *ngIf="inputs.type === 'input-complete'">
            </app-auto-complete>
          </div>
        </div>
        <div class="col-2 button-box" *ngIf="model?.tabSelected == 2 && model.tabFilterRadioSelected === 0">
          <button mat-raised-button class="xs" (click)="clearInputsValue()">LIMPAR</button>
          <button mat-raised-button class="xs white" (click)="search()">FILTRAR</button>
        </div>
      </div>
    </div>
  </div>
  <div class="custody-content">
    <div class="spinner" *ngIf="loading">
      <app-spinner-loading></app-spinner-loading>
    </div>
    <div class="content table-responsive">
      <div
        *ngIf="!loading && (model?.tabSelected == 0 || model?.tabSelected == 1 || model?.tabSelected == 2) && model.tabFilterRadioSelected !== 3">
        <table class="col-12 table table-striped table-sm">
          <thead>
            <tr>
              <th *ngFor="let item of columnDisplayTables" class="{{item.cellClass}}">{{item.headerName}}</th>
            </tr>
          </thead>
          <!-- Bovespa -> atual -->
          <ng-container *ngIf="model?.tabSelected == 0 && model.tabFilterRadioSelected === 0">
            <tbody *ngIf="gridBovTablePositionCurrent.length > 0; else emptyTabMessage">
              <tr *ngFor="let item of gridBovTablePositionCurrent">
                <ng-container *ngTemplateOutlet="buttonsAction; context: {$implicit:item}"></ng-container>
                <td class="txt-left">{{ item.quote }}</td>
                <td class="txt-center">{{ item.quoteType }}</td>
                <td class="txt-right" [ngClass]="{'high': item.initQuantityColor > 0, 'low': item.initQuantityColor < 0}">
                  {{ item.initQuantity }}</td>
                <td class="txt-right"
                  [ngClass]="{'high': item.currentQuantityColor > 0, 'low': item.currentQuantityColor < 0}">
                  {{ item.currentQuantity }}</td>
                <td class="txt-right">{{ item.lastTrade }}</td>
                <td class="txt-right">{{ item.previusTrade }}</td>
                <td class="txt-right" [ngClass]="{'high': item.variation[0] === '+', 'low': item.variation[0] === '-'}">
                  {{ item.variation }}
                </td>
                <td class="txt-right">
                  {{ (formats.custody.averagePrice) ? (item.averagePrice  | numberFormat:formats.custody.averagePrice) : item.averagePrice  }}
                </td>
                <td class="txt-right">{{ item.valueInit }}</td>
                <td class="txt-right">{{ item.valueCurrent }}</td>
                <td class="txt-right" [ngClass]="{'high': item.executedBuyColor > 0, 'low': item.executedBuyColor < 0}">
                  {{ item.executedBuy }}</td>
                <td class="txt-right" [ngClass]="{'high': item.executedSellColor > 0, 'low': item.executedSellColor < 0}">
                  {{ item.executedSell }}</td>
                <td class="txt-right">{{ item.openBuy }}</td>
                <td class="txt-right">{{ item.openSell }}</td>
                <td class="txt-right"
                  [ngClass]="{'high': item.quantityBlockedColor > 0, 'low': item.quantityBlockedColor < 0}">
                  {{ item.quantityBlocked }}</td>
                <td class="txt-right"
                  [ngClass]="{'high': item.quantityReleasedColor > 0, 'low': item.quantityReleasedColor < 0}">
                  {{ item.quantityReleased }}</td>
                <td class="txt-right" [ngClass]="{'high': item.quantityD1Color > 0, 'low': item.quantityD1Color < 0}">
                  {{ item.quantityD1 }}</td>
                <td class="txt-right" [ngClass]="{'high': item.quantityD2Color > 0, 'low': item.quantityD2Color < 0}">
                  {{ item.quantityD2 }}</td>
                <td class="txt-right" [ngClass]="{'high': item.quantityD3Color > 0, 'low': item.quantityD3Color < 0}">
                  {{ item.quantityD3 }}</td>
              </tr>
            </tbody>
          </ng-container>
          <!-- Bovespa -> dia -->
          <ng-container *ngIf="model?.tabSelected == 0 && model.tabFilterRadioSelected === 1">
            <tbody *ngIf="gridBovTablePositionDay.length > 0; else emptyTabMessage">
              <tr *ngFor="let item of gridBovTablePositionDay">
                <ng-container *ngTemplateOutlet="buttonsAction; context: {$implicit:item}"></ng-container>
                <td class="txt-left">{{ item.quote }}</td>
                <td class="txt-right" [ngClass]="{'high': item.executedBuyColor > 0, 'low': item.executedBuyColor < 0}">
                  {{ item.executedBuy }}</td>
                <td class="txt-right" [ngClass]="{'high': item.executedSellColor > 0, 'low': item.executedSellColor < 0}">
                  {{ item.executedSell }}</td>
                <td class="txt-right" [ngClass]="{'high': item.netDayColor > 0, 'low': item.netDayColor < 0}">
                  {{ item.netDay }}</td>
                <td class="txt-right">{{ item.avgValueDaytradeToday }}</td>
                <td class="txt-right"
                  [ngClass]="{'high': item.openProfitLossColor > 0, 'low': item.openProfitLossColor < 0}">
                  {{ item.openProfitLoss !== 0 ? (item.openProfitLoss | number ) : '0,00' }}
                </td>
                <td class="txt-right"
                  [ngClass]="{'high': item.closedProfitLossColor > 0, 'low': item.closedProfitLossColor < 0}">
                  {{ item.closedProfitLoss !== 0 ? (item.closedProfitLoss | number ) : '0,00' }}
                </td>
              </tr>
            </tbody>
          </ng-container>
          <!-- Bovespa -> historica -->
          <ng-container *ngIf="model?.tabSelected == 0 && model.tabFilterRadioSelected === 2">
            <tbody *ngIf="gridBovTablePositionHistory.length > 0">
              <tr *ngFor="let item of gridBovTablePositionHistory">
                <ng-container *ngTemplateOutlet="buttonsAction; context: {$implicit:item}"></ng-container>
                <td class="txt-center">{{ item.symbol }}</td>
                <td class="txt-right" [ngClass]="{'high': item.quantityColor > 0, 'low': item.quantityColor < 0}">
                  {{ item.quantity }}</td>
                <td class="txt-right">{{ item.eventDate }}</td>
                <td class="txt-right">{{ item.portfolioType }}</td>
              </tr>
            </tbody>
          </ng-container>
          <!-- BMF -> atual -->
          <ng-container *ngIf="model?.tabSelected == 1 && model.tabFilterRadioSelected === 0">
            <tbody *ngIf="gridBmfTablePositionCurrent.length > 0; else emptyTabMessage">
              <tr *ngFor="let item of gridBmfTablePositionCurrent">
                <ng-container *ngTemplateOutlet="buttonsAction; context: {$implicit:item}"></ng-container>
                <td class="txt-center">{{ item.quote }}</td>
                <td class="txt-right" [ngClass]="{'high': item.initQuantityColor > 0, 'low': item.initQuantityColor < 0}">
                  {{ item.initQuantity }}</td>
                <td class="txt-right"
                  [ngClass]="{'high': item.currentQuantityColor > 0, 'low': item.currentQuantityColor < 0}">
                  {{ item.currentQuantity }}</td>
                <td class="txt-right" [ngClass]="{'high': item.executedBuyColor > 0, 'low': item.executedBuyColor < 0}">
                  {{ item.executedBuy }}</td>
                <td class="txt-right" [ngClass]="{'high': item.executedSellColor > 0, 'low': item.executedSellColor < 0}">
                  {{ item.executedSell }}</td>
                <td class="txt-right">{{ item.lastTrade }}</td>
                <td class="txt-right">{{ item.previusTrade }}</td>
                <td class="txt-right" [ngClass]="{'high': item.variation[0] === '+', 'low': item.variation[0] === '-'}">
                  {{ item.variation }}
                </td>
                <td class="txt-right"
                  [ngClass]="{'high': item.valueAdjustedAmountColor > 0, 'low': item.valueAdjustedAmountColor < 0}">
                  {{ item.valueAdjustedAmount !== 0 ? (item.valueAdjustedAmount | number ) : '0,00' }}
                </td>
              </tr>
            </tbody>
          </ng-container>
          <!-- Bmf -> dia -->
          <ng-container *ngIf="model?.tabSelected == 1 && model?.tabFilterRadioSelected === 1">
            <tbody *ngIf="gridBmfTablePositionDay.length > 0; else emptyTabMessage">
              <tr *ngFor="let item of gridBmfTablePositionDay">
                <ng-container *ngTemplateOutlet="buttonsAction; context: {$implicit:item}"></ng-container>
                <td class="txt-center">{{ item.quote }}</td>
                <td class="txt-right" [ngClass]="{'high': item.executedBuyColor > 0, 'low': item.executedBuyColor < 0}">
                  {{ item.executedBuy }}</td>
                <td class="txt-right" [ngClass]="{'high': item.executedSellColor > 0, 'low': item.executedSellColor < 0}">
                  {{ item.executedSell }}</td>
                <td class="txt-right" [ngClass]="{'high': item.netDayColor > 0, 'low': item.netDayColor < 0}">
                  {{ item.netDay }}</td>
                <td class="txt-right">{{ item.averagePricePos }}</td>
                <td class="txt-right"
                  [ngClass]="{'high': item.openProfitLossColor > 0, 'low': item.openProfitLossColor < 0}">
                  {{ item.openProfitLoss !== 0 ? (item.openProfitLoss | number ) : '0,00' }}
                </td>
                <td class="txt-right"
                  [ngClass]="{'high': item.closedProfitLossColor > 0, 'low': item.closedProfitLossColor < 0}">
                  {{ item.closedProfitLoss !== 0 ? (item.closedProfitLoss | number ) : '0,00' }}
                </td>
              </tr>
            </tbody>
          </ng-container>
          <!-- Proventos -> Creditadas -->
          <ng-container *ngIf="model?.tabSelected == 2 && model?.tabFilterRadioSelected === 0">
            <tbody *ngIf="gridEarningsCredited.length > 0">
              <tr *ngFor="let item of gridEarningsCredited">
                <ng-container *ngTemplateOutlet="buttonsAction; context: {$implicit:item}"></ng-container>
                <td class="txt-left">{{ item.issuingName }}</td>
                <td class="txt-center">{{ item.symbol }}</td>
                <td class="txt-center">{{ item.eventDate }}</td>
                <td class="txt-left">{{ item.productName }}</td>
                <td class="txt-right">{{ item.quantity }}</td>
                <td class="txt-right">{{ item.bruteValue }}</td>
              </tr>
            </tbody>
            <div *ngIf="gridEarningsCredited.length <= 0 && showInpuEmptytDate" class="empty-table-message">
              <app-empty-result
                icon="click" [message]="msgSelectDateBeginAndFinal" [complement]="msgSelectDateBeginAndFinalComplement"
              ></app-empty-result>
            </div>
            <div *ngIf="gridEarningsCredited.length <= 0 && !showInpuEmptytDate && wasEarningsCreditedFetched">
              <ng-container *ngTemplateOutlet="emptyTabMessage"></ng-container>
            </div>
          </ng-container>
          <!-- Proventos -> Provisionadas -->
          <ng-container *ngIf="model?.tabSelected == 2 && model?.tabFilterRadioSelected === 1">
            <tbody *ngIf="gridEarningsProvisioned.length > 0; else emptyTabMessage">
              <tr *ngFor="let item of gridEarningsProvisioned">
                <ng-container *ngTemplateOutlet="buttonsAction; context: {$implicit:item}"></ng-container>
                <td class="txt-left">{{ item.issuingName }}</td>
                <td class="txt-center">{{ item.symbol }}</td>
                <td class="txt-center">{{ item.eventDate }}</td>
                <td class="txt-left">{{ item.productName }}</td>
                <td class="txt-right">{{ item.quantity }}</td>
                <td class="txt-right">{{ item.bruteValue }}</td>
              </tr>
            </tbody>
          </ng-container>
        </table>
      </div>
      <div class="row empty-history" *ngIf="
        (model?.tabSelected == 0 && model.tabFilterRadioSelected === 2) &&
        showEmptyData && !loading && showInpuEmptytDate && !showResult
      ">
        <ng-container *ngTemplateOutlet="emptyTabMessage"></ng-container>
      </div>
      <div class="row empty-history" *ngIf="((model?.tabSelected == 0 && model.tabFilterRadioSelected === 2))
        && !showEmptyData && !loading && showInpuEmptytDate && !showResult">
        <div class="empty-table-message">
          <app-empty-result
            icon="click" [message]="msgSelectDate" [complement]="msgSelectDateComplement"
          ></app-empty-result>
        </div>
      </div>
      <div class="row m-0 view-graph" *ngIf="!loading && model?.tabSelected == 0 && model.tabFilterRadioSelected === 3">
        <div class="col-3 fixed-text">{{ this?.model?.filtersInputTab?.length > 1 ? 'Selecione modo de visualização:' :
          'Modo de visualização:'}}</div>
        <div class="col-12 p-0">
          <mat-tab-group (selectedTabChange)="changeTabGroup($event)">
            <mat-tab *ngFor="let itemTab of this.model.filtersInputTab" label="{{itemTab.desc}}">
              <div class="row spinner" *ngIf="loadingGraph">
                <app-spinner-loading></app-spinner-loading>
              </div>
              <div class="row" *ngIf="!loadingGraph">
                <div class="col-12" *ngIf="positionSumary?.length <= 0">
                  <ng-container *ngTemplateOutlet="emptyTabMessage"></ng-container>
                </div>
                <div class="col-4" *ngIf="positionSumary?.length > 0">
                  <div #chartClass id="chartClass" *ngIf="model?.tabSelected == 0 && itemTab.id === 0 && showGraph">
                  </div>
                  <!-- TODO: Aguardando serviço ser desenvolvido no OMS e WF -->
                  <!-- <div #chartSector id="chartSector" *ngIf="model?.tabSelected == 0 && itemTab.id === 1 && positionSumary?.length > 0"></div> -->
                </div>
                <div class="col-8 summary-table-section" *ngIf="positionSumary?.length > 0">
                  <table class="col-12 table table-striped table-sm">
                    <thead>
                      <tr>
                        <th *ngFor="let itemHeader of columnDisplayTables" class="{{itemHeader.cellClass}}">
                          {{itemHeader.headerName}}
                        </th>
                      </tr>
                    </thead>
                    <tbody *ngIf="model?.tabSelected == 0 && itemTab.id === 0">
                      <tr *ngFor="let item of positionSumary">
                        <td class="txt-left">
                          <div class="circle {{item.class}}"></div><span class="text">{{item.name}}</span>
                        </td>
                        <td class="txt-right">R$ {{item.y != 0 ? (item.y | number) : '0,00'}}</td>
                        <td class="txt-right">{{item.percent | percent:'1.2':'pt'}}</td>
                        <td class="txt-right">R$ {{item.profitClosed != 0 ? (item.profitClosed | number) :'0,00'}}</td>
                      </tr>
                    </tbody>
                    <!-- TODO: Aguardando serviço ser desenvolvido no OMS e WF -->
                    <!-- <tbody *ngIf="model?.tabSelected == 0 && itemTab.id === 1">
                      <tr *ngFor="let item of positionSumary">
                        <td class="txt-left">
                          <div class="circle {{item.class}}"></div>
                          <span class="text">{{item.name}}</span>
                        </td>
                        <td class="txt-right">R$ {{item.y}}</td>
                        <td class="txt-right">100%</td>
                        <td class="txt-right">R$ 100.000,00</td>
                      </tr>
                    </tbody> -->
                  </table>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>

  <ng-template #emptyTabMessage>
    <div class="empty-table-message">
      <app-empty-result></app-empty-result>
    </div>
  </ng-template>
</div>

<ng-template #buttonsAction let-item>
  <td class="txt-left workspace-combobox custody-action">
    <div class="buy-sell">
      <button class="btn buy" (click)="openBillet('BUY',item)" matTooltipPosition="above"
        matTooltip="Boleta de Compra">C</button>
      <button class="btn sell" (click)="openBillet('SELL',item)" matTooltipPosition="above"
        matTooltip="Boleta de Venda">V</button>
    </div>
  </td>
</ng-template>
